export const BloodDrip = () => (
  <span className="blood-drip-line" aria-hidden="true">
    <span style={{ left: "16%", animationDuration: "3.6s" }} />
    <span style={{ left: "48%", animationDuration: "4.4s", animationDelay: "1.2s" }} />
    <span style={{ left: "78%", animationDuration: "3s", animationDelay: "0.5s" }} />
  </span>
);
